export const worksheets = {
  title: 'Munkalapok',
  subtitle: 'Sablon alapú munkalapok kezelése digitális aláírással',
  new: 'Új munkalap',
  edit: 'Munkalap szerkesztése',
  view: 'Munkalap megtekintése',
  delete: 'Munkalap törlése',
  
  // Status
  status: {
    draft: 'Vázlat',
    assigned: 'Kiszignált',
    in_progress: 'Folyamatban',
    review_pending: 'Ellenőrzésre vár',
    completed: 'Befejezve',
    sent: 'Elküldve',
    partially_invoiced: 'Részben számlázva',
    invoiced: 'Számlázva',
    cancelled: 'Törölve',
    hibernated: 'Hibernált'
  },
  
  // Work types
  workTypes: {
    installation: 'Telepítés',
    maintenance: 'Karbantartás',
    repair: 'Javítás',
    inspection: 'Ellenőrzés',
    other: 'Egyéb'
  },
  
  // Priority
  priority: {
    low: 'Alacsony',
    medium: 'Közepes',
    high: 'Magas'
  },
  
  // Fields
  fields: {
    title: 'Munkalap címe',
    description: 'Leírás',
    customer: 'Ügyfél',
    workType: 'Munka típusa',
    status: 'Állapot',
    priority: 'Prioritás',
    dueDate: 'Határidő',
    location: 'Helyszín',
    workDetails: 'Munka részletei',
    materials: 'Anyagok',
    equipment: 'Eszközök',
    safetyNotes: 'Biztonsági megjegyzések',
    estimatedHours: 'Becsült órák',
    actualHours: 'Tényleges órák',
    signatures: 'Aláírások',
    documents: 'Dokumentumok',
    worksheetDate: 'Munkalap dátuma',
    startTime: 'Kezdés',
    endTime: 'Befejezés',
    travelInfo: 'Utazási információk',
    travelKmStart: 'Kezdő km',
    travelKmEnd: 'Befejező km',
    travelKmTotal: 'Összesen',
    travelCosts: 'Utazási költségek',
    deploymentInfo: 'Kiszállási információk',
    deployment: 'Kiszállás',
    deploymentOccurred: 'Történt kiszállás',
    deploymentDate: 'Kiszállás dátuma',
    deploymentTime: 'Kiszállás időpontja',
    deploymentYes: 'Megtörtént',
    materialsAndEquipment: 'Anyagok és eszközök',
    specialNotes: 'Speciális megjegyzések',
    unknownCustomer: 'Ismeretlen ügyfél',
    deploymentAndTravel: 'Kiszállás és utazás',
    additionalInfo: 'További információk',
    additionalNotesPlaceholder: 'További megjegyzések, észrevételek...',
    totalKm: 'Összesen megtett km',
    travelCostFt: 'Utazási költség (Ft)',
    save: 'Mentés',
    cancel: 'Mégse'
  },
  
  // Actions
  actions: {
    create: 'Létrehozás',
    edit: 'Szerkesztés',
    view: 'Megtekintés',
    delete: 'Törlés',
    complete: 'Befejezés',
    sign: 'Aláírás',
    addSignature: 'Aláírás hozzáadása',
    add: 'Hozzáad',
    close: 'Bezárás',
    print: 'Nyomtat',
    downloadPdf: 'PDF letöltése'
  },
  
  // Messages
  messages: {
    noWorksheets: 'Nincsenek munkalapok',
    noWorksheetsDescription: 'Kezdjen az első munkalap létrehozásával.',
    createSuccess: 'Munkalap sikeresen létrehozva',
    createError: 'Hiba történt a munkalap létrehozásakor',
    updateSuccess: 'Munkalap sikeresen frissítve',
    updateError: 'Hiba történt a munkalap frissítésekor',
    deleteSuccess: 'Munkalap sikeresen törölve',
    deleteError: 'Hiba történt a munkalap törlésekor',
    confirmDelete: 'Biztosan törölni szeretné ezt a munkalapot?',
    confirmTitle: 'Munkalap törlése',
    deleteQuestion: 'Biztosan törölni szeretné ezt a munkalapot?',
    deleteWarning: 'Ezt a műveletet nem lehet visszavonni!',
    signatureAdded: 'Aláírás sikeresen hozzáadva',
    signatureError: 'Hiba történt az aláírás hozzáadásakor',
    signatureRemoved: 'Aláírás törölve',
    signatureRemoveError: 'Hiba történt az aláírás törlésekor',
    completed: 'Munkalap befejezve',
    completedError: 'Hiba történt a munkalap befejezésekor',
    noSignatures: 'Nincsenek aláírások',
    printBlocked: 'Popup blokkolva - engedélyezd a popup ablakokat a nyomtatáshoz',
    pdfSuccess: 'PDF sikeresen letöltve',
    pdfError: 'Hiba történt a PDF generálásakor'
  },
  
  // Filters
  filters: {
    all: 'Összes',
    allTypes: 'Minden típus',
    byStatus: 'Állapot szerint',
    byType: 'Típus szerint'
  },
  
  // Items
  items: {
    title: 'Tételek',
    name: 'Megnevezés',
    quantity: 'Menny.',
    unit: 'Egység',
    unitPrice: 'Egységár',
    vat: 'ÁFA',
    netTotal: 'Nettó',
    grossTotal: 'Bruttó',
    total: 'Összesen:',
    net: 'Nettó:',
    gross: 'Bruttó:',
    add: 'Tétel hozzáadása',
    remove: 'Eltávolítás',
    headerPlaceholder: 'Címsor neve...',
    namePlaceholder: 'Megnevezés...',
    empty: 'Még nincs tétel hozzáadva. Kattints a fenti gombokra.'
  },
  
  // Tasks
  tasks: {
    title: 'Feladatok',
    completed: 'kész',
    add: 'Feladat hozzáadása',
    progress: '{completed}/{total} kész'
  },
  
  // Time tracking
  timeTracking: {
    title: 'Munkaidő',
    start: 'Indítás',
    stop: 'Leállítás',
    manual: 'Manuális bevitel',
    startLabel: 'Kezdés',
    endLabel: 'Befejezés',
    workers: 'dolgozó',
    description: 'Leírás',
    duration: 'Időtartam',
    type: 'Típus',
    manualType: 'Manuális',
    timerType: 'Stopper',
    workersCount: 'Dolgozók',
    add: 'Hozzáad',
    personTimes: '× ember',
    noEntries: 'Még nincs rögzített munkaidő.'
  },
  
  // Notes
  notes: {
    title: 'Megjegyzések',
    add: 'Megjegyzés hozzáadása',
    customer: 'Ügyfélnek látható',
    internal: 'Belső',
    placeholder: 'Írja ide a megjegyzést...',
    remove: 'Törlés'
  },
  
  // Print
  print: {
    title: 'MUNKALAP',
    subtitle: 'YouCRM a Te CRM rendszered',
    generatedAt: 'Generálva:',
    basicInfo: 'Alapadatok',
    workTime: 'Munkaidő',
    domain: 'youcrm.hu'
  },
  
  // Quick dates
  quickDates: {
    day1: '+1 nap',
    day3: '+3 nap',
    day5: '+5 nap',
    day8: '+8 nap',
    week1: '+1 hét',
    week2: '+2 hét',
    month1: '+1 hónap'
  },
  
  // Templates
  templates: {
    title: 'Munkalap sablonok',
    new: 'Új munkalap sablon',
    name: 'Sablon neve',
    nameRequired: 'A sablon neve kötelező',
    noOrganization: 'Nincs szervezet',
    loading: 'Betöltés...',
    empty: 'Még nincs sablon létrehozva.',
    confirmDelete: 'Biztosan törlöd ezt a sablont?',
    category: 'Kategória',
    estimatedHours: 'Becsült órák',
    priority: 'Prioritás',
    defaultItems: 'Alapértelmezett tételek',
    addItem: '+ Tétel',
    defaultTasks: 'Alapértelmezett feladatok',
    addTask: '+ Feladat',
    taskName: 'Feladat neve',
    minutes: 'perc',
    create: 'Sablon létrehozása',
    cancel: 'Mégse',
    description: 'Leírás',
    itemsCount: 'tétel',
    tasksCount: 'feladat',
    categoryName: {
      installation: 'Beüzemelés',
      maintenance: 'Karbantartás',
      repair: 'Javítás',
      inspection: 'Felülvizsgálat',
      other: 'Egyéb'
    }
  }
}; 